// extracted by mini-css-extract-plugin
module.exports = {"ForBackup":"ForBackup_ForBackup__EIuhI"};